export default __webpack_public_path__ + "blackbird.011b60aa.png";